module.exports = {
  NEXT_RACE: 'next-race',
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
  SHOW_RESULTS: 'show-results',
  COMPLETED: 'completed'
}
